export enum UserRole {
    CorpUser = "Corp User",
    FacilityAdmin = "Facility Admin",
    FacilityUser = "Facility User",
    Physician = "Physician",
    TapestryAdmin = "Tapestry Admin",
    TapestryClinician = "Tapestry Clinican",
    TapestryAuditor = "Tapestry Auditor",
    TapestryQualityReviewer = "Tapestry Quality Reviewer",
}
